import React from 'react';
import ReactDOM from 'react-dom';
import videojs from 'video.js';
/* Warning: do not import components from material ui into video.js components */
import { Switch } from './index.styles';
const CaptionSwitch = () => (React.createElement(Switch, null,
    React.createElement("input", { type: "checkbox", id: "caption-switch-checkbox" }),
    React.createElement("span", { className: "slider round" })));
const vjsComponent = videojs.getComponent('Button');
class MenuCaptions extends vjsComponent {
    constructor(player, options) {
        super(player, options);
        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this);
        /* When player is ready, call method to mount React component */
        player.ready(() => {
            const tracks = player.textTracks();
            if (!this.tracksContainCaptions(tracks)) {
                this.disable();
                tracks.onaddtrack = (e) => {
                    const { track } = e;
                    if ((track === null || track === void 0 ? void 0 : track.kind) === 'captions' || (track === null || track === void 0 ? void 0 : track.kind) === 'subtitles') {
                        this.enable();
                    }
                };
            }
            this.mount();
        });
        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el());
        });
    }
    buildCSSClass() {
        return `vjs-closed-caption-button ${super.buildCSSClass()}`;
    }
    handleClick() {
        const switchButton = this.$('#caption-switch-checkbox');
        if (switchButton.getAttribute('checked') === 'true') {
            switchButton.removeAttribute('checked');
            this.controlCaptions(false);
        }
        else {
            switchButton.setAttribute('checked', 'true');
            this.controlCaptions(true);
        }
    }
    controlCaptions(active) {
        const tracks = this.player().textTracks();
        for (let i = 0; i < tracks.length; i++) {
            const track = tracks[i];
            // find the captions track that's in english
            if (track.language.startsWith('en')) {
                track.mode = active ? 'showing' : 'hidden';
                break;
            }
        }
    }
    tracksContainCaptions(tracks) {
        let hasCaptions = false;
        for (let index = 0; index < tracks.length; index++) {
            const track = tracks[index];
            if (track.kind === 'captions' || track.kind === 'subtitles') {
                hasCaptions = true;
                break;
            }
        }
        return hasCaptions;
    }
    /**
     * We will render out the React CaptionSwitch component into the DOM element
     * generated automatically by the VideoJS createEl() method.
     *
     * We fetch that generated element using `this.el()`, a method provided by the
     * vjsComponent class that this class is extending.
     */
    mount() {
        ReactDOM.render(React.createElement(CaptionSwitch, null), this.el());
    }
}
export default MenuCaptions;
//# sourceMappingURL=MenuCaptions.js.map